import { getEltyAuthToken } from '@/api/eltyAuth';
import { clientEnv } from '@/config/env/client';
import { Patient } from '@/types/patient';

export const getLoggedPatient = async (): Promise<Patient | null> => {
  const eltyAuthToken = await getEltyAuthToken();

  if (!eltyAuthToken) {
    return null;
  }

  const patientResponse = await fetch(`${clientEnv.NEXT_PUBLIC_PATIENT_BACKEND_URL}/patients/me`, {
    headers: {
      Authorization: `Bearer ${eltyAuthToken}`,
      'Content-Type': 'application/json',
    },
  });

  if (!patientResponse.ok) {
    throw new Error(`HTTP error! status: ${patientResponse.status}`);
  }

  const patient = (await patientResponse.json()) as Patient | null;

  return patient;
};
